<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Add Financial Report</h4>
                                <h5 class="card-subtitle"> Please keep your profile information always current in order
                                    to help you when you contact us. </h5>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label class="form-label font-weight-bold required">Financial Year Ending
                                        Date</label>
                                </div>
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <input :class="{'is-invalid': submitted && errors.has('year_ending_date')}"
                                           autocomplete="off"
                                           class="form-control"
                                           data-vv-as="Financial Year Ending Date"
                                           id="year_ending_date"
                                           name="year_ending_date"
                                           type="date"
                                           v-model="report.year_ending_date"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('year_ending_date')">{{
                                        errors.first('year_ending_date') }}
                                    </div>
                                </div>
                            </div>
                            <ul class="nav nav-tabs mt-4 mb-4" role="tablist">
                                <li :key="index" @click="navigate(tab.index)" class="nav-item"
                                    v-for="(tab, index) in tabs">
                                    <a :class="{active: activeTab === tab.index}" @click="navigate(tab.index)"
                                       class="nav-link" data-toggle="tab"
                                       role="tab" v-bind:href="'#'+tab.name">
                                        <span class="hidden-sm-up"></span>
                                        <span class="hidden-xs-down ml-1">{{tab.name}}</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div :class="{'d-none': activeTab !== tab.index}" :id="tab.name" :key="index"
                                     class="tab-pane active" v-for="(tab, index) in tabs">
                                    <add-financial-report-tab-content :events="events" :id="tab.id"
                                                                      :input_fields="tab.fields"
                                                                      :name="tab.name"
                                                                      :report="report"></add-financial-report-tab-content>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AddFinancialReportTabContent from "./AddFinancialReportTabContent";
    import {mapGetters} from "vuex";
    import Vue from "vue";

    export default {
        name: "AddFinancialReport",
        components: {AddFinancialReportTabContent},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                activeTab: 1,
                submitted: false,
                events: new Vue(),
                tabs: [
                    {
                        "index": 1,
                        "name": "Balance Sheet",
                        "id": "balance_sheet",
                        "description": "",
                        "fields": [
                            {
                                "db": "equity_and_liabilities",
                                "label": "A. Equity and Liabilities",
                                "type": "json",
                                "display_value": false,
                                "fields": [
                                    {
                                        "db": "stockholders_fund",
                                        "label": "1. Shareholders’ funds",
                                        "type": "json",
                                        "display_value": false,
                                        "fields": [
                                            {
                                                "db": "share_capital",
                                                "label": "(a) Share capital",
                                                "type": "number"
                                            },
                                            {
                                                "db": "reserves_and_surplus",
                                                "label": "(b) Reserves and surplus",
                                                "type": "number"
                                            },
                                            {
                                                "db": "total_shareholders_funds",
                                                "label": " Total of  Shareholders’ funds",
                                                "type": "number",
                                                "readonly": true
                                            }
                                        ]
                                    },
                                    {
                                        "db": "non_current_liabilities",
                                        "label": "2. Non-current liabilities",
                                        "type": "json",
                                        "display_value": false,
                                        "fields": [
                                            {
                                                "db": "long_term_borrowings",
                                                "label": "(a) Long-term borrowings",
                                                "type": "number"
                                            },
                                            {
                                                "db": "deferred_tax_liabilities",
                                                "label": "(b) Deferred tax liabilities (net)",
                                                "type": "number"
                                            },
                                            {
                                                "db": "other_long_term_liabilities",
                                                "label": "(c) Other long-term liabilities",
                                                "type": "number"
                                            },
                                            {
                                                "db": "total_non_current_liabilities",
                                                "label": " Total of  Non-current liabilities",
                                                "type": "number",
                                                "readonly": true
                                            }
                                        ]
                                    },
                                    {
                                        "db": "current_liabilities",
                                        "label": "3. Current liabilities",
                                        "type": "json",
                                        "display_value": false,
                                        "fields": [
                                            {
                                                "db": "short_term_borrowings",
                                                "label": "(a) Short-term borrowings",
                                                "type": "number"
                                            },
                                            {
                                                "db": "trade_parables",
                                                "label": "(b) Trade payables",
                                                "type": "number"
                                            },
                                            {
                                                "db": "other_current_liabilities",
                                                "label": "(c) Other current liabilities",
                                                "type": "number"
                                            },
                                            {
                                                "db": "total_current_liabilities",
                                                "label": " Total of current liabilities",
                                                "type": "number",
                                                "readonly": true
                                            }
                                        ]
                                    },
                                    {
                                        "db": "total_equity",
                                        "label": " Total of Equity and Liabilities",
                                        "type": "number",
                                        "readonly": true
                                    }
                                ]
                            },
                            {
                                "db": "assets",
                                "label": "B.Assets",
                                "type": "json",
                                "display_value": false,
                                "fields": [
                                    {
                                        "db": "non_current_assets",
                                        "label": "1. Non-current assets",
                                        "type": "json",
                                        "display_value": false,
                                        "fields": [
                                            {
                                                "db": "fixed_assets",
                                                "label": "(a) Fixed assets",
                                                "type": "json",
                                                "display_value": false,
                                                "fields": [
                                                    {
                                                        "db": "tangible_assets",
                                                        "label": "(i) Tangible assets",
                                                        "type": "number"
                                                    },
                                                    {
                                                        "db": "intangible_assets",
                                                        "label": "(ii) Intangible assets",
                                                        "type": "number"
                                                    },
                                                    {
                                                        "db": "total_of_fixed_assets",
                                                        "label": "Total of Fixed assets",
                                                        "type": "number",
                                                        "readonly": true
                                                    }
                                                ]
                                            },
                                            {
                                                "db": "non_current_investments",
                                                "label": "(b) Non-current investments",
                                                "type": "number"
                                            },
                                            {
                                                "db": "deferred_tax_assets",
                                                "label": "(c) Deferred tax assets (net)",
                                                "type": "number"
                                            },
                                            {
                                                "db": "long_term_loans_advances",
                                                "label": "(d) Long Term Loans & Advances",
                                                "type": "number"
                                            },
                                            {
                                                "db": "total_non_current_assets",
                                                "label": " Total of Non-current assets",
                                                "type": "number",
                                                "readonly": true
                                            }
                                        ]
                                    },
                                    {
                                        "db": "current_assets",
                                        "label": "2.Current assets",
                                        "type": "json",
                                        "display_value": false,
                                        "fields": [
                                            {
                                                "db": "current_investments",
                                                "label": "(a) Current investments",
                                                "type": "number"
                                            },
                                            {
                                                "db": "inventories",
                                                "label": "(b) Inventories",
                                                "type": "number"
                                            },
                                            {
                                                "db": "trade_receivables",
                                                "label": "(c) Trade receivables",
                                                "type": "number"
                                            },
                                            {
                                                "db": "cash_and_cash_equivalents",
                                                "label": " (d) Cash And Cash Equivalents",
                                                "type": "number"
                                            },
                                            {
                                                "db": "short_term_loans_advances",
                                                "label": " (e) Short-term loans and advances",
                                                "type": "number"
                                            },
                                            {
                                                "db": "other_current_assets",
                                                "label": "(f) Other Current Assets",
                                                "type": "number"
                                            },
                                            {
                                                "db": "total_current_assets",
                                                "label": " Total of Current Assets",
                                                "type": "number",
                                                "readonly": true
                                            }
                                        ]
                                    },
                                    {
                                        "db": "total_assets",
                                        "label": " Total of Assets",
                                        "type": "number",
                                        "readonly": true
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "index": 2,
                        "name": "Profit & Loss",
                        "id": "profit_and_loss",
                        "description": "",
                        "fields": [
                            {
                                "db": "revenue",
                                "label": "(A) Revenue",
                                "type": "json",
                                "display_value": false,
                                "fields": [
                                    {
                                        "db": "revenue_from_operations",
                                        "label": "(a) Revenue from operations",
                                        "type": "number"
                                    },
                                    {
                                        "db": "other_income",
                                        "label": "(b) Other Income",
                                        "type": "number"
                                    },
                                    {
                                        "db": "total_revenue",
                                        "label": " Total Revenue",
                                        "type": "number",
                                        "readonly": true
                                    }
                                ]
                            },
                            {
                                "db": "expenses",
                                "label": "(B) Expenses:",
                                "type": "json",
                                "display_value": false,
                                "fields": [
                                    {
                                        "db": "cost_of_rendering_services",
                                        "label": "(a) Cost of rendering services",
                                        "type": "number"
                                    },
                                    {
                                        "db": "purchases",
                                        "label": "(b) Purchases",
                                        "type": "number"
                                    },
                                    {
                                        "db": "increase_decrease",
                                        "label": "(c) (Increase) / Decrease In Work-In-Progress",
                                        "type": "number"
                                    },
                                    {
                                        "db": "employee_benefit_expense",
                                        "label": "(d) Employee benefit expense",
                                        "type": "number"
                                    },
                                    {
                                        "db": "finance_cost",
                                        "label": "(e) Finance Cost",
                                        "type": "number"
                                    },
                                    {
                                        "db": "depreciation",
                                        "label": "(f) Depreciation",
                                        "type": "number"
                                    },
                                    {
                                        "db": "other_expenses",
                                        "label": "(g) Other expenses",
                                        "type": "number"
                                    },
                                    {
                                        "db": "total_expenses",
                                        "label": " Total Expenses",
                                        "type": "number",
                                        "readonly": true
                                    }
                                ]
                            },
                            {
                                "db": "profit_before_tax",
                                "label": "(C) Profit before tax (A-B)",
                                "type": "number",
                                "readonly": true
                            },
                            {
                                "db": "tax_expenses",
                                "label": "(D)Tax expense:",
                                "type": "json",
                                "display_value": false,
                                "fields": [
                                    {
                                        "db": "current_tax",
                                        "label": "(a) Current Tax Expense For Current Year",
                                        "type": "number"
                                    },
                                    {
                                        "db": "current_tax_expense",
                                        "label": "(b) Current Tax Expense Relating To Prior Years",
                                        "type": "number"
                                    },
                                    {
                                        "db": "deferred_tax",
                                        "label": "(c) Deferred Tax Expense / (Income)",
                                        "type": "number"
                                    },
                                    {
                                        "db": "total_tax_expenses",
                                        "label": " Total Tax expenses",
                                        "type": "number",
                                        "readonly": true
                                    }
                                ]
                            },
                            {
                                "db": "profit_after_tax",
                                "label": "(E) Profit after tax (C-D)",
                                "type": "number",
                                "readonly": true
                            }
                        ]
                    }
                ],
                report: {
                    "year_ending_date": null,
                    "balance_sheet": {
                        "equity_and_liabilities": {
                            "stockholders_fund": {
                                "share_capital": 0,
                                "reserves_and_surplus": 0,
                                "total_shareholders_funds": 0
                            },
                            "non_current_liabilities": {
                                "long_term_borrowings": 0,
                                "deferred_tax_liabilities": 0,
                                "other_long_term_liabilities": 0,
                                "total_non_current_liabilities": 0
                            },
                            "current_liabilities": {
                                "short_term_borrowings": 0,
                                "trade_parables": 0,
                                "other_current_liabilities": 0,
                                "total_current_liabilities": 0
                            },
                            "total_equity": 0
                        },
                        "assets": {
                            "non_current_assets": {
                                "fixed_assets": {
                                    "tangible_assets": 0,
                                    "intangible_assets": 0,
                                    "total_of_fixed_assets": 0
                                },
                                "non_current_investments": 0,
                                "deferred_tax_assets": 0,
                                "long_term_loans_advances": 0,
                                "total_non_current_assets": 0
                            },
                            "current_assets": {
                                "current_investments": 0,
                                "inventories": 0,
                                "trade_receivables": 0,
                                "cash_and_cash_equivalents": 0,
                                "short_term_loans_advances": 0,
                                "other_current_assets": 0,
                                "total_current_assets": 0
                            },
                            "total_assets": 0
                        }
                    },
                    "profit_and_loss": {
                        "revenue": {
                            "revenue_from_operations": 0,
                            "other_income": 0,
                            "total_revenue": 0
                        },
                        "expenses": {
                            "cost_of_rendering_services": 0,
                            "purchases": 0,
                            "increase_decrease": 0,
                            "employee_benefit_expense": 0,
                            "finance_cost": 0,
                            "depreciation": 0,
                            "other_expenses": 0,
                            "total_expenses": 0
                        },
                        "profit_before_tax": 0,
                        "tax_expenses": {
                            "current_tax": 0,
                            "current_tax_expense": 0,
                            "deferred_tax": 0,
                            "total_tax_expenses": 0
                        },
                        "profit_after_tax": 0
                    }
                }
            }
        },
        methods: {
            navigate(index) {
                this.activeTab = index;
            },
            handleSubmit(e) {
                this.submitted = true;
                this.events.$emit('reporttab:validate');
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.submit();
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async submit() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.put('/marketplaces/' + this.currentOrg.marketplace_id + '/financialreports', this.report);
                    this.$toastr('success', 'Financial record successfully created', 'Purchase Added');
                    await this.$router.push({
                        name: 'view-finance-report',
                        params: {financialreportid: data.financial_report_id}
                    });
                } catch (e) {
                    this.$toastr('error', 'Financial record submission failed!', 'Failed');
                }finally {
                    $(".preloader").fadeOut();
                }
            },
            reset() {
                this.report = {
                    "year_ending_date": null,
                    "balance_sheet": {
                        "equity_and_liabilities": {
                            "stockholders_fund": {
                                "share_capital": 0,
                                "reserves_and_surplus": 0,
                                "total_shareholders_funds": 0
                            },
                            "non_current_liabilities": {
                                "long_term_borrowings": 0,
                                "deferred_tax_liabilities": 0,
                                "other_long_term_liabilities": 0,
                                "total_non_current_liabilities": 0
                            },
                            "current_liabilities": {
                                "short_term_borrowings": 0,
                                "trade_parables": 0,
                                "other_current_liabilities": 0,
                                "total_current_liabilities": 0
                            },
                            "total_equity": 0
                        },
                        "assets": {
                            "non_current_assets": {
                                "fixed_assets": {
                                    "tangible_assets": 0,
                                    "intangible_assets": 0,
                                    "total_of_fixed_assets": 0
                                },
                                "non_current_investments": 0,
                                "deferred_tax_assets": 0,
                                "long_term_loans_advances": 0,
                                "total_non_current_assets": 0
                            },
                            "current_assets": {
                                "current_investments": 0,
                                "inventories": 0,
                                "trade_receivables": 0,
                                "cash_and_cash_equivalents": 0,
                                "short_term_loans_advances": 0,
                                "other_current_assets": 0,
                                "total_current_assets": 0
                            },
                            "total_equity": 0
                        }
                    },
                    "profit_and_loss": {
                        "revenue": {
                            "revenue_from_operations": 0,
                            "other_income": 0,
                            "total_revenue": 0
                        },
                        "expenses": {
                            "cost_of_rendering_services": 0,
                            "purchases": 0,
                            "increase_decrease": 0,
                            "employee_benefit_expense": 0,
                            "finance_cost": 0,
                            "depreciation": 0,
                            "other_expenses": 0,
                            "total_expenses": 0
                        },
                        "profit_before_tax": 0,
                        "tax_expenses": {
                            "current_tax": 0,
                            "current_tax_expense": 0,
                            "deferred_tax": 0,
                            "total_tax_expenses": 0
                        },
                        "profit_after_tax": 0
                    }
                };
            }
        }
    }
</script>

<style scoped>

</style>
